<template>
  <b>Proyecto PEER AEROSOLES en el IGP</b>
  <p>
    Impacto del transporte transfronterizo de contaminantes del aire sobre los
    Andes Centrales de Perú relacionados a la quema de vegetación en la
    Amazonía. (
    <a href="http://ohy.igp.gob.pe/instrumentos/principal" target="_blank">
      más información
    </a>
    )
  </p>
  <b>Proyecto AERONET en la NASA</b>
  <p>
    La colaboración de AERONET proporciona observaciones distribuidas a nivel
    mundial de profundidad óptica de aerosol espectral (AOD), productos de
    inversión y agua precipitable en diversos regímenes de aerosoles. (
    <a href="http://bit.ly/aeronethyo" target="_blank">
      más información
    </a>
    )
  </p>
</template>
<script>
export default {
  components: {
  }
};
</script>
